module.exports = __webpack_public_path__ + "img/uis.8f34b0f4.svg";